import AboutMerchant from './AboutMerchant';

export default AboutMerchant;
